const accountTypeTransfeeraAPI = require('../accountType');

const accountType = {
  checking: 'checking',
  payment: 'payment',
  savings: 'savings',
  salary: 'salary',
  convertToPayoutEngine(type) {
    return {
      [accountTypeTransfeeraAPI.CONTA_CORRENTE]: this.checking,
      [accountTypeTransfeeraAPI.CONTA_SALARIO]: this.salary,
      [accountTypeTransfeeraAPI.CONTA_POUPANCA]: this.savings,
      [accountTypeTransfeeraAPI.CONTA_PAGAMENTO]: this.payment,
      [accountTypeTransfeeraAPI.CONTA_FACIL]: this.checking,
      [accountTypeTransfeeraAPI.ENTIDADES_PUBLICAS]: this.payment
    }[type];
  }
};

module.exports = accountType;
